import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  text = 'EMPEZAR HOY',
  subtext = 'Oferta 50% OFF por tiempo limitado.',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://rinconebook.shop/cart/48290841100543:1" className={`group relative inline-flex flex-col items-center justify-center px-8 py-4 text-center font-bold text-white transition-all duration-300 bg-rose-500 rounded-2xl hover:bg-rose-600 hover:shadow-[0_0_40px_rgba(244,63,94,0.4)] hover:-translate-y-1 ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-208">
      <div className="flex items-center gap-2 text-xl md:text-2xl tracking-wide" data-id="element-209">
        {text}
        <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1" data-id="element-210" />
      </div>
      {subtext && <span className="mt-1 text-sm md:text-base font-medium text-rose-100 opacity-90" data-id="element-211">
          {subtext}
        </span>}

      {/* Shine effect */}
      <div className="absolute inset-0 overflow-hidden rounded-2xl" data-id="element-212">
        <div className="absolute top-0 left-[-100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-20deg] group-hover:animate-[shine_1.5s_ease-in-out]" data-id="element-213" />
      </div>
    </motion.a>;
}